import React from 'react'
import { Box, Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import {
  DateFormat,
  DateUtils,
  type Nil,
  PuiCheckbox,
} from '@pbt/pbt-ui-components'

import Typography from '~/components/elements/Typography/Typography'

const useStyles = makeStyles(
  (theme) => ({
    children: {
      marginLeft: theme.spacing(3),
    },
    checkbox: {
      padding: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
    checkboxLabel: {
      fontSize: '1.4rem',
    },
  }),
  { name: 'EmailDialogSectionItem' },
)

export interface EmailDialogSectionItemProps {
  addedDate?: string | null
  checked: boolean
  children: any[]
  id: string
  name: string
  onCheckedChange: (id: string, checked: boolean) => void
}

const EmailDialogSectionItem = ({
  id,
  name,
  checked,
  children,
  onCheckedChange,
  addedDate,
}: EmailDialogSectionItemProps) => {
  const classes = useStyles()

  const getNameWithFormattedDate = (
    date: string | Nil,
    displayName: string,
  ) => {
    if (!date) {
      return displayName
    }

    const formattedDate = DateUtils.formatDate(
      date,
      true,
      DateFormat.FULL_DATE_COMMA,
    )
    return date ? `${displayName} ${formattedDate}` : displayName
  }

  return (
    <Grid container>
      <PuiCheckbox
        checkboxClasses={{
          root: classes.checkbox,
        }}
        checked={checked}
        className={classes.checkboxLabel}
        label={getNameWithFormattedDate(addedDate, name)}
        onChange={() => onCheckedChange(id, !checked)}
      />
      {children && (
        <Grid container className={classes.children}>
          {children.map((item) => {
            if (item.unselectable) {
              if (!item.name) {
                return null
              }

              return (
                <Box
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  key={item.id}
                  width="100%"
                >
                  <Typography.ParagraphSm sx={{ ml: 2, mr: 'auto' }}>
                    {/* We display the parent added date */}
                    {getNameWithFormattedDate(addedDate, item.name)}
                  </Typography.ParagraphSm>
                </Box>
              )
            }

            return (
              <EmailDialogSectionItem
                key={item.id}
                onCheckedChange={onCheckedChange}
                {...item}
              />
            )
          })}
        </Grid>
      )}
    </Grid>
  )
}

export default EmailDialogSectionItem
